import { db } from './db';

/**
 * localStorage から IndexedDB への最終データ移行
 */
export const runLastMigration = async () => {
  const MIGRATION_DONE_KEY = 'hibi_migration_v5_done';
  if (localStorage.getItem(MIGRATION_DONE_KEY)) return;

  // React StrictMode 等の並行実行を防ぐためのメモリロック
  if ((window as any)._migrationLock) return;
  (window as any)._migrationLock = true;

  console.log('[Migration] Starting safe migration from localStorage...');

  try {
    // 1. 習慣データの移行 (既存データがないか確認して重複挿入を防止)
    const existingHabitsCount = await db.habits.count();
    if (existingHabitsCount === 0) {
      const oldHabitsStr = localStorage.getItem('syukan_habits');
      if (oldHabitsStr) {
        const oldHabits = JSON.parse(oldHabitsStr);
        for (const h of oldHabits) {
          await db.habits.put({
            ...h,
            reminderEnabled: h.reminderEnabled ? 1 : 0,
            isArchived: h.isArchived ? 1 : 0,
            createdAt: h.createdAt ? new Date(h.createdAt) : new Date(),
            updatedAt: h.updatedAt ? new Date(h.updatedAt) : new Date(),
          });
        }
      }
    }

    // 2. 記録データの移行
    const existingRecordsCount = await db.records.count();
    if (existingRecordsCount === 0) {
      const oldRecordsStr = localStorage.getItem('syukan_records');
      if (oldRecordsStr) {
        const oldRecords = JSON.parse(oldRecordsStr);
        for (const r of oldRecords) {
          await db.records.put({
            ...r,
            createdAt: r.createdAt ? new Date(r.createdAt) : new Date(),
            updatedAt: r.updatedAt ? new Date(r.updatedAt) : new Date(),
          });
        }
      }
    }

    // 3. 統計の移行
    const joinedDate = localStorage.getItem('hibi_joined_date');
    if (joinedDate) {
      await db.stats.update('current', { joinedDate: new Date(joinedDate) });
    }

    // 4. 設定の移行
    const oldSettingsStr = localStorage.getItem('syukan_settings');
    if (oldSettingsStr) {
      const oldSettings = JSON.parse(oldSettingsStr);
      await db.settings.update('current', {
        language: oldSettings.language || 'ja',
        soundEnabled: oldSettings.soundEnabled !== undefined ? oldSettings.soundEnabled : true,
      });
    }

    // 移行完了マーク
    localStorage.setItem(MIGRATION_DONE_KEY, 'true');
    
    // 古いキーの削除
    const keysToRemove = [
      'syukan_habits', 'syukan_records', 'syukan_reminders', 
      'syukan_settings', 'hibi_badges', 'hibi_user_stats',
      'userId', 'guestUserId', 'hibi_joined_date'
    ];
    keysToRemove.forEach(key => localStorage.removeItem(key));

    console.log('[Migration] Migration completed successfully.');
  } catch (error) {
    console.error('[Migration] Migration encountered an error:', error);
  } finally {
    (window as any)._migrationLock = false;
  }
};
